import type { EvidenceUploadMode, ModelResults } from 'api';

export const getAnalysisStatusUsingBaleModel = (
  model_results: ModelResults,
  mode: EvidenceUploadMode
): 'rejected-material' | 'accepted' => {
  if (model_results.outputs?.[0]?.highest_grade_name === 'Reject') {
    return 'rejected-material';
  }

  if (mode === 'inspector' && !model_results.outputs?.[0]?.acceptance) {
    return 'rejected-material';
  }

  return 'accepted';
};
